import React from 'react';
import { connect } from 'react-redux';

import Entities from '../components/common/Entities';
import Table from '../components/customers/Table';
import EditModal from '../components/customers/EditModal';
import Filter from '../components/customers/Filter';
import {
    fetchCustomers as fetchCustomersAction,
    createCustomer as createCustomerAction,
    updateCustomer as updateCustomerAction,
    clearCreateCustomer as clearCreateCustomerAction,
    clearUpdateCustomer as clearUpdateCustomerAction,
    clearCustomers as clearCustomersAction,
    clearSmsInfo as clearSmsInfoAction
} from '../actions/customers';
import {
    required as phoneRequired,
    validate as phoneValidate,
    parsePhoneNumber
} from '../extensions/phoneHelper'
import { Col, Grid, Row } from 'react-bootstrap';
import SmsSendModal from '../components/common/SmsSendModal';
import Pagination from 'react-js-pagination';
import * as fetchingState from '../constants/fetchingState';
import * as qs from 'qs';


let Customers = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                name: null,
                phone: null,
                page: 1
            },
            isFilterValid: false,
            showFilterError: false,
            showSmsSendModal: false
        }
        const { pathname, search } = this.props.location;
        const params = qs.parse(search, { ignoreQueryPrefix: true });
        params.page = 1;
        const url = `${pathname}?${qs.stringify(params, { arrayFormat: 'repeat' })}`;
        this.props.history.push(url);

        this._load = this._load.bind(this);
        this._update = this._update.bind(this);
        this._create = this._create.bind(this);
        this._clearCrudAction = this._clearCrudAction.bind(this);
        this._filterChanged = this._filterChanged.bind(this);
        this._validateFilter = this._validateFilter.bind(this);
        this._onSmsSendModalClose = this._onSmsSendModalClose.bind(this);
        this._onSmsSendModalOpen = this._onSmsSendModalOpen.bind(this);
        this._pageChanged = this._pageChanged.bind(this);
    }

    _onSmsSendModalClose() {
        this.setState({showSmsSendModal: false});
        this.props.clearSmsInfoAction();
    }

    _onSmsSendModalOpen(Phone) {
        this.props.clearSmsInfoAction();
        this.setState({showSmsSendModal: true, smsModal: <SmsSendModal Phone={Phone} onClose={this._onSmsSendModalClose} />});
    }

    _load(activePage) {
        const { isFilterValid, filter: { name, phone } } = this.state;
        const page = activePage ? activePage : 1;
        if (!activePage)
        {
            const { pathname, search } = this.props.location;
            const params = qs.parse(search, { ignoreQueryPrefix: true });
            params.page = 1;
            const url = `${pathname}?${qs.stringify(params, { arrayFormat: 'repeat' })}`;
            this.props.history.push(url);
        }

        if (isFilterValid) {

            this.props.fetchCustomersAction({
                name,
                phone: phone ? parsePhoneNumber(phone) : null,
                page: page            
            });
        }
        else
            this.setState({ showFilterError: true })
    }

    componentWillUnmount() {
        this.props.clearCustomersAction();
    }

    _update(customer) {
        this.props.updateCustomerAction(customer);
    }

    _create(customer) {
        this.props.createCustomerAction(customer);
    }

    _clearCrudAction(isNew) {
        isNew ? this.props.clearCreateCustomerAction() : this.props.clearUpdateCustomerAction();
    }

    _filterChanged(filterData) {
        const { location: { search } } = this.props;
        const page = qs.parse(search, { ignoreQueryPrefix: true }).page ? +qs.parse(search, { ignoreQueryPrefix: true }).page : 1;
        this.setState({
            filter: { ...filterData, page: page },
            showFilterError: false
        });
    }

    _validateFilter({ name, phone }) {
      const errors = {};
        if (!phoneRequired(phone) && phoneValidate(phone))
            errors.phone = '*Некорректный номер';


        this.setState({ isFilterValid: Object.keys(errors).length === 0 })
        return errors;
    }

    _pageChanged(activePage) {
        const { pathname, search } = this.props.location;
        const params = qs.parse(search, { ignoreQueryPrefix: true });
        params.page = activePage;
        const url = `${pathname}?${qs.stringify(params, { arrayFormat: 'repeat' })}`;
        this.props.history.push(url);
        this._load(activePage);
    }


    render() {
        const { customers, pages, totalAmount, perPage, fetching, updateFetching, createFetching, updateResult, location: { search }, createResult } = this.props;
        const { showFilterError, filter } = this.state;
        const activePage = qs.parse(search, { ignoreQueryPrefix: true }).page ? +qs.parse(search, { ignoreQueryPrefix: true }).page : 1;

        const smsSendModal = (<Row>
            <Col lg={12}>
                {this.state.smsModal}
            </Col>
        </Row>);
        return (
            <div>
                {this.state.showSmsSendModal && smsSendModal}
                <Filter onChange={this._filterChanged} initialValues={{ ...filter }} showError={showFilterError} validate={this._validateFilter} />
                <Entities
                    entities={customers}
                    fetching={fetching}
                    updateFetching={updateFetching}
                    createFetching={createFetching}
                    updateResult={updateResult}
                    createResult={createResult}
                    header='Клиенты'
                    contentTable={Table}
                    onSmsSendOpen={this._onSmsSendModalOpen}
                    editModal={EditModal}
                    loadAction={this._load}
                    updateAction={this._update}
                    createAction={this._create}
                    clearCrudAction={this._clearCrudAction}
                    reloadOnModalClosing={false}
                />
                <Grid>
                    <Row>
                        <Col lg={12} style={{ textAlign: 'center' }}>
                            {fetching === fetchingState.FETCHED && customers.length > 0 && totalAmount > perPage && <Pagination
                                totalItemsCount={totalAmount}
                                onChange={this._pageChanged}
                                activePage={activePage}
                                itemsCountPerPage={perPage}
                                pageRangeDisplayed={15} />}
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

Customers = connect(state => ({
    ...state.application.get('customer')
}), {
    fetchCustomersAction,
    createCustomerAction,
    updateCustomerAction,
    clearCreateCustomerAction,
    clearUpdateCustomerAction,
    clearCustomersAction,
    clearSmsInfoAction
})(Customers);


export default Customers;


// WEBPACK FOOTER //
// ./src/containers/Customers.jsx